import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import en from './locales/en.json'
import ro from './locales/ro.json'

import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'billing',
  menu: [
    {
      title: <FormattedMessage id="finance.menu.title" />,
      key: 'billing',
      icon: 'icmn icmn-credit-card',
      children: [
        {
          title: <FormattedMessage id="finance.menu.transactions" />,
          key: 'finance.transactions',
          url: '/finance/transactions',
        },
        {
          title: <FormattedMessage id="finance.menu.billing" />,
          key: 'finance.billing',
          url: '/finance/billing',
        },
        {
          title: <FormattedMessage id="cards.menu.title" />,
          key: 'cards.list',
          url: '/finance/cards',
        },
      ],
      roles: ['business'],
    },
  ],
  routes: [
    {
      path: '/finance/billing',
      async lazy() {
        const Comp = await import('./pages/transactions')
        return { Component: Comp.default }
      },
      exact: true,
    },
    {
      path: '/finance/transactions',
      async lazy() {
        const Comp = await import('./pages/transactions')
        return { Component: Comp.default }
      },
      exact: true,
    },
    {
      path: '/finance/cards',
      async lazy() {
        const Comp = await import('./pages/cards')
        return { Component: Comp.default }
      },
      exact: true,
    },
    {
      path: '/finance/cards/add',
      async lazy() {
        const Comp = await import('./pages/cards/add')
        return { Component: Comp.default }
      },
      exact: true,
    },
  ],
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}

export { default as Wallet } from './components/TopBar/Wallet'
